/* @flow */

import { useStore } from 'react-redux';

import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';

import type { RouteData } from 'src/shared/app/base/route/type/routeTypes';

export default function useRoutes(...args: Array<RouteData>): Array<string> {
  const state = useStore().getState();

  return args.map((route) => getRoutePath(route, state));
}
